import Link from '@/components/Link';
import { cltw } from 'ui/utils';

interface NavigationMenuListItemProps {
  title: string;
  href?: string;
  className?: string;
  children?: React.ReactNode;
}

export const NavigationMenuListItem = ({
  className,
  title,
  href,
  children,
}: NavigationMenuListItemProps): JSX.Element => {
  const wrapperClassName = cltw(
    'block select-none space-y-1 rounded-md p-3 leading-none no-underline transition-colors',
    className,
  );

  const titleElement = <span className='text-sm font-medium'>{title}</span>;

  return (
    <li>
      {href ? (
        <Link className={wrapperClassName} href={href}>
          {titleElement}
        </Link>
      ) : (
        <div className={wrapperClassName}>{titleElement}</div>
      )}
      {children ? <div className='text-sm'>{children}</div> : null}
    </li>
  );
};
